const THEME_KEY = 'theme'

function getInitialTheme() {
  const saved = localStorage.getItem(THEME_KEY)
  if (saved) return saved === 'dark'
  return true
}

export default {
  namespaced: true,
  state: {
    isDark: getInitialTheme()
  },
  mutations: {
    toggleTheme(state) {
      state.isDark = !state.isDark
      localStorage.setItem(THEME_KEY, state.isDark ? 'dark' : 'light')
    }
  }
}
